import { Box, Button, Flex, Text } from 'pcln-design-system'
import { Cars, Hotels, Verified } from 'pcln-icons'
import React from 'react'

const getIcon = (iconName) => {
  switch (iconName) {
    case 'verified':
      return Verified
    case 'hotels':
      return Hotels
    default:
      return Cars
  }
}

const Information = ({
  id,
  iconName,
  iconText,
  headLine,
  subHeadLine,
  button,
  onClick,
  isButtonDisplayed = true,
}) => {
  const Icon = getIcon(iconName)
  return (
    <Box>
      <Flex>
        <Box
          color='background.base'
          style={{ borderRadius: '100%' }}
          width={['56px', null, null, null, '72px']}
          height={['56px', null, null, null, '72px']}
        >
          <Icon data-testid={iconName} color='primary.base' size='100%' p={3} />
        </Box>
        <Text
          m='auto'
          style={{ whiteSpace: 'pre-wrap' }}
          color='primary.dark'
          ml={3}
          fontSize={1}
          lineHeight='19px'
        >
          {iconText}
        </Text>
      </Flex>
      <Text
        mt={3}
        style={{ whiteSpace: 'pre-wrap' }}
        color='primary'
        fontSize={[4, null, null, null, 5]}
        lineHeight={['33px', null, null, null, '44px']}
      >
        {headLine}
      </Text>
      <Text
        mt={[3, null, null, 4]}
        color='text.light'
        fontSize={['12px', null, null, '16px']}
        lineHeight={['24px', null, null, '32px']}
      >
        {subHeadLine}
      </Text>
      {isButtonDisplayed && (
        <Button
          mt={4}
          onClick={() => {
            const click = onClick
            click(id)
          }}
        >
          {button}
        </Button>
      )}
    </Box>
  )
}

export default Information
